import { APP_LOGO_SRC, APP_NAME } from '../lib/brand';

type BrandLogoProps = {
  size?: 'sm' | 'md' | 'lg';
  showName?: boolean;
  className?: string;
};

const sizeClasses = {
  sm: 'w-16',
  md: 'w-20',
  lg: 'w-32',
} as const;

export function BrandLogo({ size = 'md', showName = false, className = '' }: BrandLogoProps) {
  return (
    <div className={`flex items-center gap-4 ${className}`}>
      <img
        src={APP_LOGO_SRC}
        alt={APP_NAME}
        className={`${sizeClasses[size]} shrink-0 rounded-lg object-contain`}
      />
      {showName && <span className="font-bold text-xl text-orange-300">{APP_NAME}</span>}
    </div>
  );
}

export function BrandLogoMark({ size = 'md', className = '' }: Pick<BrandLogoProps, 'size' | 'className'>) {
  return (
    <img
      src={APP_LOGO_SRC}
      alt={APP_NAME}
      className={`${sizeClasses[size]} shrink-0 rounded-lg object-contain ${className}`}
    />
  );
}
